<template>
  <div class="element-input element-complete">
    <div class="body">
      <div :class="{ on: true }" class="title">{{ data.title }}</div>
      <div class="label">{{ data.label }}</div>
      <div class="link" @click="$parent.$parent.doneProcessor('MyInsurance')">신청한 견적서 내역 보러가기<img :src="'../static/chevron_right.png'"/></div>
      <div class="link" @click="$parent.$parent.forceBlockNextStep()">다른 보험 표준 견적서 받아보기<img :src="'../static/chevron_right.png'"/></div>
      
    </div>
  </div>
</template>
<script>
export default {
  props: [ "data", "error" ],
  data() {
    return {
    }
  },
  created () {
    this.$trackingService('init', '001-004-761');
    this.$trackingService('track', 'CompleteRegistration');
  },
  methods: {
  }
}
</script>
